import {
    AppShell,
    Avatar,
    Box,
    Burger,
    Group,
    NavLink as MantineNavLink,
    Stack,
    Text,
    ThemeIcon,
    UnstyledButton,
} from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import {
    IconBook2,
    IconCoins,
    IconCompass,
    IconLayoutDashboard,
    IconLogout,
    IconRoute,
    IconSettings,
} from '@tabler/icons-react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';

import { t } from '../dictionary';
import { useAuth } from '../providers/auth-context';

export const AppLayout = () => {
    const { partner, logout } = useAuth();
    const [opened, { toggle, close }] = useDisclosure();
    const navigate = useNavigate();

    const links = [
        { to: '/', label: t.nav.dashboard, icon: IconLayoutDashboard, end: true },
        { to: '/quests', label: t.nav.stories, icon: IconBook2, end: false },
        { to: '/routes', label: t.nav.routes, icon: IconRoute, end: false },
        { to: '/earnings', label: t.nav.earnings, icon: IconCoins, end: false },
        { to: '/settings', label: t.nav.settings, icon: IconSettings, end: false },
    ];

    return (
        <AppShell
            header={{ height: 60 }}
            navbar={{ width: 260, breakpoint: 'sm', collapsed: { mobile: !opened } }}
            padding='lg'
            bg='gray.0'
        >
            <AppShell.Header>
                <Group h='100%' px='md' justify='space-between'>
                    <Group gap='xs'>
                        <Burger opened={opened} onClick={toggle} hiddenFrom='sm' size='sm' />
                        <ThemeIcon size={30} radius='md' variant='filled' color='indigo'>
                            <IconCompass size={18} />
                        </ThemeIcon>
                        <Box visibleFrom='xs'>
                            <Text fw={700} size='sm' lh={1.1}>
                                {t.common.brand}
                            </Text>
                            <Text size='xs' c='dimmed' lh={1.1}>
                                {t.common.portal}
                            </Text>
                        </Box>
                    </Group>

                    <UnstyledButton
                        onClick={() => navigate('/settings')}
                        aria-label={t.settings.openSettings}
                        style={{ borderRadius: '50%' }}
                    >
                        <Avatar
                            src={partner.avatarUrl || undefined}
                            color='indigo'
                            radius='xl'
                            size='sm'
                        >
                            {partner.name?.charAt(0)?.toUpperCase()}
                        </Avatar>
                    </UnstyledButton>
                </Group>
            </AppShell.Header>

            <AppShell.Navbar p='sm'>
                <Stack justify='space-between' h='100%'>
                    <Box>
                        {links.map((link) => (
                            <MantineNavLink
                                key={link.to}
                                component={NavLink}
                                to={link.to}
                                end={link.end}
                                label={link.label}
                                onClick={close}
                                leftSection={<link.icon size={18} stroke={1.7} />}
                                styles={{ root: { borderRadius: 8 } }}
                            />
                        ))}
                    </Box>

                    <UnstyledButton
                        onClick={async () => {
                            await logout();
                            navigate('/login');
                        }}
                        p='sm'
                    >
                        <Group gap='xs'>
                            <IconLogout size={18} stroke={1.7} />
                            <Text size='sm'>{t.nav.logout}</Text>
                        </Group>
                    </UnstyledButton>
                </Stack>
            </AppShell.Navbar>

            <AppShell.Main>
                <Box maw={960} mx='auto'>
                    <Outlet />
                </Box>
            </AppShell.Main>
        </AppShell>
    );
};
